import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { albanyNyConfig } from "./data";

export default function AlbanyNYPage() {
  return <CityPageTemplate config={albanyNyConfig} />;
}